// ********* Delight - Dentist Website is created by Zpunet ******************
// ********* If you get an error please contact us ******
// ******** Email:info@codemarketi.com *********
// ********* Website:www.codemarketi.com *********
// ********* Phone:+255 762 352 746 *********
// ********* Youtub Channel: https://www.youtube.com/channel/UCOYwYO-LEsrjqBs6xXSfq1w *********

// ******** Support my work with *********
// ********* https://www.patreon.com/zpunet *********
// ********* https://www.buymeacoffee.com/zpunet *********

// ********* This is the main component of the website *********

import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { authRoles } from './auth/authRoles';
import Aos from 'aos';
import Analytics from './screens/Analytics';
import Dashboard from './screens/Dashboard';
import Payments from './screens/Payments/Payments';
import Appointments from './screens/Appointments';
import Patients from './screens/Patients/Patients';
import Campaings from './screens/Campaings';
import Services from './screens/Services';
import Invoices from './screens/Invoices/Invoices';
import Settings from './screens/Settings';
import CreateInvoice from './screens/Invoices/CreateInvoice';
import EditInvoice from './screens/Invoices/EditInvoice';
import PreviewInvoice from './screens/Invoices/PreviewInvoice';
import EditPayment from './screens/Payments/EditPayment';
import PreviewPayment from './screens/Payments/PreviewPayment';
import Medicine from './screens/Medicine';
import PatientProfile from './screens/Patients/PatientProfile';
import CreatePatient from './screens/Patients/CreatePatient';
import Doctors from './screens/Doctors/Doctors';
import DoctorProfile from './screens/Doctors/DoctorProfile';
import Receptions from './screens/Receptions';
import NewMedicalRecode from './screens/Patients/NewMedicalRecode';
import NotFound from './screens/NotFound';
import Login from './screens/Login';
import Profile from './screens/Settings/Profile';
import EditLab from './screens/Settings/Edit-Lab';
import NewLab from './screens/Settings/New-Lab';
import AddNewCase from './screens/Cases/AddNewCase'
import SignUp from './screens/Register';
import ForgotPassword from './screens/ForgotPassword';
import Notification from './screens/Settings/Notification';
import SchedulingTemplates from './screens/Settings/Scheduling-Templates';
import ProductExtras from './screens/Settings/Product-Extras';
import Products from './screens/Settings/Product';
import Materials from './screens/Settings/Materials';
import SingleProduct from './screens/Settings/SingleProduct';
import SingleExtra from './screens/Settings/SingleExtra';
import SingleMaterial from './screens/Settings/SingleMaterial';
import Subscriptions from './screens/Settings/Subscription';
import SingleTask from './screens/Settings/SingleTask';
import SwitchLab from './screens/Settings/Switch-Lab';
import Invitation from './screens/Settings/invitation';
import MyTask from './screens/Tasks/MyTasks';
import AllCases from './screens/Cases';
import CaseDetail from './screens/Cases/CaseDetail';
import Employees from './screens/Employees';
import WorkLog from './screens/WorkLog';
import Overview from './screens/Clinic/Overview'

function App() {
  Aos.init();

  return (
    <>
      {/* Routes */}
      <BrowserRouter>
        <Routes>
          <Route path="/" auth={authRoles.admin} element={<Analytics />} />
          {/* analytics */}
          <Route path="/dashboard" auth={authRoles.admin} element={<Dashboard />} />

          {/* new case */}
          <Route path="add-new-case" element={<AddNewCase />} auth={authRoles.admin} />
          <Route path="all-cases" element={<AllCases />} auth={authRoles.admin} />
          <Route path="/all-cases/:id" element={<CaseDetail />} auth={authRoles.admin} />

          {/* invoce */}
          <Route path="/invoices" element={<Invoices />} auth={authRoles.admin} />
          <Route path="/invoices/create" element={<CreateInvoice />} auth={authRoles.admin} />
          <Route path="/invoices/edit/:id" element={<EditInvoice />} auth={authRoles.admin} />
          <Route path="/invoices/preview/:id" element={<PreviewInvoice />} auth={authRoles.admin} />

          {/* payments */}
          <Route path="/payments" element={<Payments />} />
          <Route path="/payments/edit/:id" element={<EditPayment />} />
          <Route path="/payments/preview/:id" element={<PreviewPayment />} />

          {/* patient */}
          <Route path="/patients" element={<Patients />} />
          <Route path="/patients/preview/:id" element={<PatientProfile />} />
          <Route path="/patients/create" element={<CreatePatient />} />
          <Route path="/patients/visiting/:id" element={<NewMedicalRecode />} />

          {/* doctors */}
          <Route path="/doctors" element={<Doctors />} />
          <Route path="/doctors/preview/:id" element={<DoctorProfile />} />

          {/* reception */}
          <Route path="/receptions" element={<Receptions />} />

          {/* WorkLog */}
          <Route path="/work-logs" element={<WorkLog />} />

          {/* Employees */}
          <Route path="/employees" element={<Employees />} />

          {/* settings */}
          <Route path="settings" element={<Settings />} />
          <Route path="profile" element={<Profile />} />
          <Route path="edit-lab" element={<EditLab />} />
          <Route path="new-lab" element={<NewLab />} />
          <Route path="switch-lab" element={<SwitchLab />} />
          <Route path="invitation" element={<Invitation />} />
          <Route path="notifications" element={<Notification />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="tasks" element={<MyTask />} />
          <Route path="tasks/:id" element={<SingleTask />} />
          <Route path="scheduling-tasks" element={<SchedulingTemplates />} />
          <Route path='products' element={<Products />} />
          <Route path="products/:id" element={<SingleProduct />} />
          <Route path="extras" element={<ProductExtras />} />
          <Route path="extras/:id" element={<SingleExtra />} />
          <Route path="materials" element={<Materials />} />
          <Route path="materials/:id" element={<SingleMaterial />} />
          {/* others */}
          <Route path="login" element={<Login />} />
          <Route path="register" element={<SignUp />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="/calendar" element={<Appointments />} />
          <Route path="/appointments" element={<Appointments />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/campaigns" element={<Campaings />} />
          <Route path="/medicine" element={<Medicine />} />
          <Route path="/services" element={<Services />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
